import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'

import Panel from '../ui/Panel'
import { MediaUpload, Notice, Confirm } from './media'
import './media.css'

/*
 * SPONSOR — the main photo.
 *
 * Requests untouched:
 *   POST   admin/uploadsponsorimage        (multipart: file, id — with progress)
 *   DELETE admin/uploadsponsorimage/{id}
 *   the preview still reads admin/files/sponsor/{id}/{cache-buster}
 *
 * What changed: the progress bar is real (it was painted even when nothing was
 * uploading, and the percentage sat next to a red "Uploading! Please Wait!"
 * banner that never went away on failure), every alert() is now an inline
 * message inside this panel, and the delete question is answered in place
 * instead of in a browser dialog.
 */

const FileUploadSponsor = (props) => {

  const [file, setFile] = useState('')
  const [fileName, setFileName] = useState('Please select an MP4 file')
  const [upLoading, setUpLoading] = useState(false)
  const [uploadPercentage, setUploadPercentage] = useState(0)
  const [url, setUrl] = useState('')
  const [title, setTitle] = useState('')
  const [photo, setPhoto] = useState('')
  const [note, setNote] = useState(null)
  const [confirmDel, setConfirmDel] = useState(false)

  const inputRef = useRef(null)

  useEffect(() => {

    loadFile(props.id)

    setUrl(process.env.REACT_APP_API_SERVER + 'admin/uploadsponsorimage')
    setFileName('Please select an image file')
    setTitle('Upload  Photo.')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type])


  useEffect(() => {
    loadFile(props.id)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id])

  const fileChanged = (picked) => {
    if (!picked) return
    if (picked.type.indexOf('image/') > -1) {
      setFile(picked)
      setFileName(picked.name)
      setNote(null)
    } else {
      setFile('')
      setFileName('Please select an image file')
      setNote({ kind: 'crit', text: 'Please Select an IMAGE file' })
    }
  }

  const uploadFile = async e => {
    e.preventDefault()
    if (!file) {
      setNote({ kind: 'crit', text: 'Please select an image file' })
      return
    }

    const formData = new FormData()
    formData.append('file', file)
    formData.append('id', props.id)
    try {
      setUpLoading(true)
      setNote(null)
      axios.post(url, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
        },
        onUploadProgress: ProgressEvent => {
          setUploadPercentage(parseInt(Math.round(ProgressEvent.loaded * 100 / ProgressEvent.total)))
        }
      }).then(res => {
        setUpLoading(false)
        if (inputRef.current) inputRef.current.value = null

        setUploadPercentage(0)
        setFile('')
        setFileName('Please select an image file')

        if (res.data.err == 0) {
          loadFile(props.id)
          props.loadData(props.id)
          setNote({ kind: 'good', text: 'Photo uploaded.' })
        } else {
          setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
        }

      }).catch(err => {
        setUpLoading(false)
        setUploadPercentage(0)
        setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
      })

    } catch (err) {
      setUpLoading(false)
      setUploadPercentage(0)
      setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
    }
  }

  const loadFile = (id) => {

    const t = Date.now()
    setPhoto(process.env.REACT_APP_API_SERVER + 'admin/files/sponsor/' + id + '/' + t)

  }

  const delFile = () => {
    setConfirmDel(false)
    axios.delete(process.env.REACT_APP_API_SERVER + 'admin/uploadsponsorimage/' + props.id, {
      headers: {
        'Authorization': 'Bearer ' + sessionStorage.getItem("apiToken")
      }
    }).then(res => {
      props.loadData(props.id)
      loadFile(props.id)
      setNote({ kind: 'good', text: 'Photo deleted.' })
    }).catch(err => {
      setNote({ kind: 'crit', text: 'An Error has occured! Please Try Again' })
    })
  }

  const hasPhoto = !!(props.record && props.record.Photo)

  return (
    <Panel title="Main Photo" subtitle={title}>
      {confirmDel ? (
        <Confirm
          text={<b>Delete File?</b>}
          confirmLabel="Delete"
          cancelLabel="Cancel"
          onConfirm={delFile}
          onCancel={() => setConfirmDel(false)}
        />
      ) : null}

      <MediaUpload
        inputId="customFile"
        inputRef={inputRef}
        hint="JPG, PNG or WEBP"
        fileName={fileName}
        onFile={fileChanged}
        onSubmit={uploadFile}
        uploading={upLoading}
        percent={uploadPercentage}
        canSubmit={!!file}
        submitLabel={'Upload' + (props.type == 1 || props.type == 0 ? ' Main Photo' : ' Sponsor Logo')}
        notice={note ? <Notice kind={note.kind} onClose={() => setNote(null)}>{note.text}</Notice> : null}
        preview={photo}
        previewAlt="Sponsor photo"
        hasFile={hasPhoto}
        onDelete={() => setConfirmDel(true)}
        deleteLabel="Delete photo"
        emptyPreview="No photo yet"
      />
    </Panel>
  )


}

export default FileUploadSponsor;
